/*
* Configuration for Feedback
*/
export default function () {
  const { $i18n: i18n } = useNuxtApp()

  return {
    blockFirstScreen: {
      hideOn: []
    },
    header: {
      hideOn: ['/designer', '/catalog', '/shared/uploader', '/shared/campaign/email-preview', '/page/custom-packaging-127', '/shared/thank-you'],
      navigation: {
        hideOn: ['/shared/campaign/claim-gift', '/shared/video-library(.*)']
      },
      info: {
        hideOn: ['/shared/campaign/claim-gift']
      },
      announcement: {
        hideOn: ['/shared/campaign/claim-gift']
      },
      heroFirst: {
        hideOn: []
      },
      myGiftsBtn: []
    },
    footer: {
      hideOn: ['/designer', '/shared/video-library(.*)', '/shared/uploader', '/shared/campaign/email-preview', '/shared/thank-you'],
      main: {
        hideOn: ['/product', '/shared/campaign/claim-gift']
      },
      advantages: {
        hideOn: ['/product']
      },
      copyright: {
        hideOn: ['/shared/campaign/claim-gift']
      }
    },
    breadcrumbs: {
      hideOn: ['/', '/shared/uploader', '/shared/campaign/claim-gift', '/shared/campaign/email-preview', '/shared/thank-you']
    },
    HelpersFormsFeedback: {
      data: {
        feedbackFields: [
          {
            id: 'fullname',
            required: true,
            classes: 's12 m6 l3',
            hidden: false,
            value: '',
            label: i18n?.t('fullName'),
            placeholder: 'John'
          },
          {
            id: 'email',
            required: true,
            classes: 's12 m6 l3',
            hidden: false,
            value: '',
            label: i18n?.t('email'),
            placeholder: 'john.smith@xyzcompany.com'
          },
          {
            id: 'telephone',
            required: false,
            classes: 's12 m6 l3',
            hidden: false,
            value: '',
            label: i18n?.t('phoneNumber'),
            placeholder: '888-848-8474'
          },
          {
            id: 'company',
            required: false,
            classes: 's12 m6 l3',
            hidden: false,
            value: '',
            label: i18n?.t('companyName'),
            placeholder: 'XYZ Company'
          },
          {
            id: 'comments',
            required: true,
            classes: 's12 m6 l9',
            hidden: false,
            value: '',
            label: i18n?.t('additionalNotes'),
            placeholder: ''
          },
          {
            id: 'submit',
            required: false,
            classes: 's12 m6 l3',
            hidden: false,
            value: '',
            externalReviews: {
              enable: true
            },
            elementClasses: 'btn-large secondary-color base-1',
            label: i18n?.t('submitQuoteRequest')
          },
          {
            id: 'subscribe',
            required: false,
            classes: 's12 m12 l12 mt-0',
            hidden: false,
            value: ''
          },
          {
            id: 'privacy',
            required: false,
            classes: 's12 m12 l12',
            hidden: false,
            value: ''
          },
          {
            id: 'privacyDisclaimer',
            required: false,
            classes: 's12 m12 l12',
            hidden: false,
            value: '',
            hiddenCheckbox: true,
            elementClasses: '',
            label: ''
          }
        ]
      }
    },
    PagesOurDifference: {
      widgetEnable: true,
      data: {
        parentClasses: 'base-section sm',
        parentStyle: 'defaultStyle',
        items: [
          {
            label: false,
            title: false,
            subTitle: false,
            descr: false,
            video: 'GXm4NX98Mp4',
            videoPreview: 'https://old.customusb.com/img/global/youtube.1601003964.jpg',
            classes: 'm6 s12'
          },
          {
            label: i18n?.t('widgets.PagesOurDifferenceProduct.items.0.label'),
            title: i18n?.t('widgets.PagesOurDifferenceProduct.items.0.title'),
            subTitle: false,
            descr: false,
            content: i18n?.t('widgets.PagesOurDifferenceProduct.items.0.content'),
            video: false,
            videoPreview: false,
            classes: 'm6 s12'
          }
        ]
      }
    },
    PopupsSubscribe: {
      widgetEnable: true,
      hideOn: ['/designer']
    },
    PopupsUnsupportedBrowser: {
      widgetEnable: true
    },
    popups: {
      cookiesAgree: {
        widgetEnable: true
      }
    }
  }
}
